import React, { useState } from 'react';
import axios from 'axios';

const TestTeamUpEvent = () => {
  const [eventId, setEventId] = useState('');
  const [loading, setLoading] = useState(false);

  const testInstructorFetch = async () => {
    if (!eventId.trim()) {
      alert('Please enter an event ID');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      console.log('Testing instructor fetch for event ID:', eventId);
      
      const response = await axios.get(`/api/field-experience-events/trainingplans/by-event/${eventId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('Raw API response:', response);
      console.log('Response data:', response.data);
      
      if (response.data && response.data.trainingPlans) {
        const instructorNames = [];
        const seen = new Set();
        
        for (const tp of response.data.trainingPlans) {
          if (tp.instructor && !seen.has(tp.instructor)) {
            seen.add(tp.instructor);
            instructorNames.push(`${tp.first_name} ${tp.last_name}`);
          }
        }
        
        console.log('Processed instructor names:', instructorNames);
        console.log('Number of unique instructors:', instructorNames.length);
      } else {
        console.log('No training plans found or unexpected response structure');
      }
      
    } catch (error) {
      console.error('Error testing instructor fetch:', error);
      console.error('Error response:', error.response);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2>Test Instructor Fetch</h2>
      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '5px' }}>
          Field Experience Event ID:
        </label>
        <input
          type="text"
          value={eventId}
          onChange={(e) => setEventId(e.target.value)}
          placeholder="Enter feevent_id (UUID)"
          style={{ 
            width: '100%', 
            padding: '8px', 
            fontSize: '14px',
            border: '1px solid #ccc',
            borderRadius: '4px'
          }}
        />
      </div>
      <button
        onClick={testInstructorFetch}
        disabled={loading}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.6 : 1
        }}
      >
        {loading ? 'Testing...' : 'Test Instructor Fetch'}
      </button>
      
      <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
        <p><strong>Instructions:</strong></p>
        <ol>
          <li>Enter a field experience event ID (UUID)</li>
          <li>Click "Test Instructor Fetch"</li>
          <li>Check the browser console (F12 → Console) for results</li>
          <li>Look for logs showing the API response and processed instructor names</li>
        </ol>
      </div>
    </div>
  );
};

export default TestTeamUpEvent; 